module.exports = __webpack_public_path__ + "static/6-a1f0e692ac77c29a6c30d93211527088.jpg";